var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"our-apps-view"},[_c('return-menu'),_c('landing-intro-secondary',{attrs:{"LandingIntroData":_vm.LandingIntroData}}),_c('ExecutiveSummary',_vm._b({},'ExecutiveSummary',_vm.ExecutiveSummaryData,false)),_c('our-app-sliders'),_c('contact-us',_vm._b({},'contact-us',_vm.ContactUsData,false)),_c('FooterLayout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }